import { FC } from 'react'
import { Tabs } from 'antd'
import { TabPaneProps } from 'antd/lib/tabs'

export const TabPane: FC<TabPaneProps> = (props) => <Tabs.TabPane {...props} />
